export const initialValues = {
  id: '',
  messaggio: '',
  gravita: null,
  attivo: '0',
};

export const mapToInitialValues = (newValues) => {
  const mappedValues = {
    id: newValues.id,
    messaggio: newValues.messaggio,
    gravita: newValues.gravita,
    attivo: newValues.attivo === false ? '0' : '1',
  };

  return mappedValues;
};

export default initialValues;



// WEBPACK FOOTER //
// ./app/components/EditorAvvisi/Form/initialValues.js